// src/router/index.js
import Vue from 'vue'
import Router from 'vue-router'

// ===== 用户侧（你原有的）=====
import LoginPage from '@/views/Login.vue'
import ServerSelectPage from '@/views/ServerSelect.vue'
import PersonalInfoPage from '@/views/PersonalInfo.vue'
import { hasValidSession } from '@/store/session'

// ===== 管理端（新增）=====
import { hasValidAdminSession } from '@/admin/session'
const AdminLogin = () => import('@/views/admin/AdminLogin.vue')
const AdminLayout = () => import('@/views/admin/AdminLayout.vue')
const AdminStats = () => import('@/views/admin/pages/StatsPage.vue')
const AdminServers = () => import('@/views/admin/pages/ServersPage.vue')
const AdminCategories = () => import('@/views/admin/pages/CategoriesPage.vue')
const AdminGoods = () => import('@/views/admin/pages/GoodsPage.vue')
const AdminOrders = () => import('@/views/admin/pages/OrdersPage.vue')
const AdminUsers = () => import('@/views/admin/pages/UsersPage.vue')
const AdminWallets = () => import('@/views/admin/pages/WalletsPage.vue')
const AdminLedger = () => import('@/views/admin/pages/LedgerPage.vue')
const AdminCarReplace = () => import('@/views/admin/pages/CarReplaceReview.vue')
const AdminSystemConfig = () => import('@/views/admin/pages/SystemConfigPage.vue')
const AdminCdkManage = () => import('@/views/admin/pages/CdkManagePage.vue')

Vue.use(Router)

const router = new Router({
  mode: 'hash',
  routes: [
    { path: '/', redirect: '/servers' },
    { path: '/login', component: LoginPage, meta: { public: true } },
    { path: '/servers', component: ServerSelectPage, meta: { public: true } },
    { path: '/shop/:serverCode', name: 'Shop', component: () => import('@/views/Shop.vue'), props: true, meta: { requiresAuth: true } },
    { path: '/profile', component: PersonalInfoPage, meta: { requiresAuth: true } },

    // ===== 管理端 =====
    { path: '/admin/login', component: AdminLogin, meta: { public: true, admin: true } },
    {
      path: '/admin',
      component: AdminLayout,
      meta: { admin: true },
      redirect: '/admin/stats',
      children: [
        { path: 'stats', component: AdminStats, meta: { admin: true } },
        { path: 'servers', component: AdminServers, meta: { admin: true } },
        { path: 'categories', component: AdminCategories, meta: { admin: true } },
        { path: 'goods', component: AdminGoods, meta: { admin: true } },
        { path: 'orders', component: AdminOrders, meta: { admin: true } },
        { path: 'cdk', component: AdminCdkManage, meta: { admin: true } },
        { path: 'users', component: AdminUsers, meta: { admin: true } },
        { path: 'wallets', component: AdminWallets, meta: { admin: true } },
        { path: 'ledger', component: AdminLedger, meta: { admin: true } },
        { path: 'system-config', component: AdminSystemConfig, meta: { admin: true } },
        { path: 'replace', component: AdminCarReplace, meta: { admin: true } }
      ]
    }
  ]
})

// 守卫：先处理 admin，再走用户侧
router.beforeEach(function (to, from, next) {
  if (to.matched.some(r => r.meta && r.meta.admin)) {
    const adminLoggedIn = hasValidAdminSession()
    const isPublic = to.matched.some(r => r.meta && r.meta.public)
    if (to.path === '/admin/login' && adminLoggedIn) return next('/admin')
    if (!isPublic && !adminLoggedIn) {
      return next({ path: '/admin/login', query: { redirect: to.fullPath } })
    }
    return next()
  }

  const loggedIn = hasValidSession()
  const requiresAuth = to.matched.some(r => r.meta && r.meta.requiresAuth)

  if (to.path === '/') return next('/servers')
  if (to.path === '/login' && loggedIn) return next('/servers')
  if (requiresAuth && !loggedIn) return next({ path: '/login', query: { redirect: to.fullPath } })
  next()
})

export default router
